import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import {number_format,number_input_format} from '../helper/format';

class Devicepricepopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      open : false,
      device_price : 0,
      original_price: 0,
    };

    this.priceTextObj = null;
  }
  Open(device_price)
  {
    this.setState({
        open: true,
        device_price : device_price,
        original_price : device_price
      });
  }
  Close()
  {
    this.setState({
      open: false
    });
  }
  ChangePrice()
  {
    if( this.priceTextObj )
    {
      this.setState({
        device_price : this.priceTextObj.value
      });
    }
  }
  applyOriginal() {
    this.setState({
      device_price : this.state.original_price
    })
  }
  Apply()
  {
    this.props.onDevicePriceChanged(this.state.device_price);
    this.Close();
  }
  Close()
  {
    this.setState({ open: false });
  }
  render()
  {
      const self = this;
      return(<Modal open={this.state.open} onClose={()=>{self.Close()}} center>
        <div className="modal-dialog modal-md mb0">
          <div className="popupPadding2 pr45">
            <div className="md-popup-header"> &nbsp;출고가 변경</div>
            <div className="md-popup-contents">
              <div>공시 출고가 : {number_input_format(self.state.original_price)} 원 &nbsp;&nbsp;<a href="#apply" onClick={()=>self.applyOriginal()} className="btn btn-default btn-small">적용</a></div>
              <div className="pt15">
                <div className="row">
                  <div className="col-xs-11">
                    <input type="number" ref={(ref)=>{this.priceTextObj = ref}} className="form-control" onChange={()=>{self.ChangePrice()}} value={this.state.device_price}/>
                  </div>
                  <div className="col-xs-1 font18 pl0 pt10">
                    원
                  </div>
                </div>
              </div>
              <div className="pt20 pl18">
                <div className="row font16">
                  변경한 출고가를 적용하시겠습니까?
                </div>
              </div>
              <div className="pt40">
                <div className="row text-center">
                  <a href="#applyPrice" onClick={()=>{self.Apply()}} className="btn btn-bar btn-lg btn-select2">확인</a>&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="#cancel" onClick={()=>{self.Close()}} className="btn btn-cancel btn-lg btn-select2">취소</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>);
  }
}

export default Devicepricepopup;
